export default {
  // baseUrl: 'http://192.168.31.130:8000/',
  baseUrl: 'http://dama-co.com:8080',
  //  baseUrl: 'http://127.0.0.1:8000',
  siteUrl: 'dama-co.com/'
}
